exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.copyright-search-wrap[data-v-50228e98] {\n  background-color: white;\n}\n", ""]);

// exports
